import { ONE_HOUR_IN_SECONDS } from '@/common/constants';

export const secondsToHours = (seconds: number): number => {
  return seconds / ONE_HOUR_IN_SECONDS;
};
